import { object, string } from "yup";

import UserInfo from "./UserInfo";
import ResourceInfo from "./ResourceInfo";
export default [
  {
    id: "user",
    component: UserInfo,
    initialValues: {
      email: "",
      role: "",
    },
    validationSchema: object().shape({
      role: string().required("Role is required"),
      email: string()
        .email("Please enter valid email address")
        .required("Email is required").max(30),
    }),
  },
  {
    id: "resource",
    component: ResourceInfo,
    initialValues: {
      name: "",
      lastname: "",
      department: "",
      designation: "",
      country: "IN",
      phone: "",
      experienceYear: "",
      experienceMonth: "",
      dateOfJoining: "",
      dob: "",
      skills: "",
      userId: ""
    },
    validationSchema: object().shape({
      name: string().required("Name is required").max(15),
      lastname: string().max(15),
      department: string().required("Department is required"),
      designation: string().required("Designation is required"),
      phone: string().required("Phone is required")

    }),
    actionLabel: "Proceed",
    onAction: (sectionValues, formValues) => {
      if (sectionValues.name === "argh!") {
        throw new Error("Please, choose a better name!");
      }
    },
  },
];
